import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getAuth } from "firebase/auth";

function CareerChangeResume() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/get-started");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="Career Change Resume Guide (2026)"
        description="Learn how to write a career change resume that highlights transferable skills and lands interviews. Switch careers with confidence using EmployPilot."
        canonical="https://employpilot.com/career-change-resume"
      />


      <h1>How to Write a Career Change Resume (Switch Careers Successfully)</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        Switching careers can feel overwhelming, especially when your experience doesn’t directly match the job.
        But with the right resume strategy, you can position your skills in a way that makes sense to employers.
      </p>

      <p style={{ fontWeight: "bold", marginTop: "15px" }}>
        The key to a career change resume is highlighting transferable skills and showing your potential—not just your past.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Build My Career Change Resume
      </button>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>What Is a Career Change Resume?</h2>

      <p>
        A career change resume focuses on skills and experiences that apply to your new field,
        rather than your previous job titles.
      </p>

      <ul>
        <li>✔ Emphasizes transferable skills</li>
        <li>✔ Highlights relevant achievements</li>
        <li>✔ Shows adaptability and growth</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>How to Structure Your Resume</h2>

      <ol>
        <li>Start with a strong summary explaining your transition</li>
        <li>Focus on relevant skills</li>
        <li>Highlight achievements that apply to your new field</li>
        <li>Include any training, certifications, or projects</li>
      </ol>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Best Skills to Highlight</h2>

      <ul>
        <li>✔ Communication and teamwork</li>
        <li>✔ Problem-solving ability</li>
        <li>✔ Leadership and initiative</li>
        <li>✔ Technical or industry-related skills</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Common Mistakes to Avoid</h2>

      <ul>
        <li>❌ Focusing too much on old job titles</li>
        <li>❌ Not explaining your career transition</li>
        <li>❌ Ignoring transferable skills</li>
        <li>❌ Using a generic resume</li>
      </ul>

      {/* 🔥 INTERNAL LINKS */}
      <p style={{ marginTop: "20px" }}>
        Need the right format?{" "}
        <Link to="/best-resume-format">
          Learn the best resume format
        </Link>
      </p>

      <p>
        Want AI to build it for you?{" "}
        <Link to="/ai-resume-builder">
          Use the AI Resume Builder
        </Link>
      </p>

      <p>
        Planning your next move?{" "}
        <Link to="/ai-career-advisor">
          Get AI career advice
        </Link>
      </p>

      {/* CTA */}
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Start Your Career Transition Today</h2>

        <button onClick={handleStart} style={btnSuccess}>
          Get Started Now
        </button>
      </div>

      {/* FAQ SECTION */}
      <h2 style={{ marginTop: "60px" }}>
        Frequently Asked Questions
      </h2>

      <h3>How do I write a resume for a career change?</h3>
      <p>
        Focus on transferable skills, relevant achievements, and explain your transition clearly in your summary.
      </p>

      <h3>Can I switch careers without experience?</h3>
      <p>
        Yes. Many employers value skills and potential over direct experience if presented correctly.
      </p>

      <h3>Does AI help with career change resumes?</h3>
      <p>
        Yes. AI tools like EmployPilot can restructure your experience and highlight transferable skills effectively.
      </p>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default CareerChangeResume;